function isHTMLElement(value) {
  return typeof value === "object" && value !== null && "nodeType" in value;
}
export {
  isHTMLElement
};
